var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAccordionIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Accordion activate") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "View-Project",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Approved---View-Project---Desktop",
    transform: "translate(-1196.000000, -2132.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Tasks/Closed/Desktop",
    transform: "translate(380.000000, 2090.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icon/Info-plus",
    transform: "translate(816.000000, 42.000000)",
    fill: "#0063C7"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    points: "22.6132034 7.41421356 12.0066017 18.0208153 1.4 7.41421356 2.81421356 6 12.0066017 15.1923882 21.1989899 6"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAccordionIcon);
export default __webpack_public_path__ + "static/media/accordion-icon.1b7622ad9d0b3bc074a0954ff0e36a1a.svg";
export { ForwardRef as ReactComponent };